export const sortMessages = (messages) =>
	messages.sort(
		(messageA, messageB) =>
			new Date(messageA.created_at).getTime() -
			new Date(messageB.created_at).getTime(),
	);
